module.exports = __webpack_public_path__ + "img/cellphone.b1bc52b1.png";